import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import Select from "react-select";
import { Button, FormGroup, Label, Row, Col, Input, CardBody, Container, Card } from "reactstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import Breadcrumbs from "components/Common/Breadcrumb";
import { fetchClaimDropdown, fetchEmployeeDropdownAutoList, saveExtraDutyClaim,fetchEmployeeDropdownAutoExtraDutyList } from "store/actions";
import { useDispatch, useSelector } from "react-redux";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import CustomSelect from "components/Common/custom-select";
import CustomDatePicker from "common/CustomDatePicker";
import CustomTimePicker from "common/CustomTimePicker";
import CustomDateTimePicker from "common/CustomDateTimePicker";
import Loader from "common/pageLoader";
import { useLocation,useHistory } from "react-router-dom";
import getAccessRights from "components/Common/getAccessRights";
import useButtonAccess from "components/Common/useButtonAccess";
import dayjs from "dayjs";

const Claim = () => {
  const [accessRight, setAccessRight] = useState(null);
  const location = useLocation();
  const history = useHistory();
  useEffect(() => {
      const rights = getAccessRights(location.pathname, history);
      setAccessRight(rights?.data);
  }, [location]);
  const { canRead, canCreate, canEdit, canDelete, canApprove } = useButtonAccess(accessRight);
  const [authDetails, setAuthDetails] = useState(null);
  const {
      dropdownAutoList,
      claimDropdownData,
      dropdownAutoExtraDutyList,
      loading,
      success,
      error,
    } = useSelector((state) => ({
      dropdownAutoList: state.EmployeeDetailsReducer?.dropdownAutoList ?? [],
      claimDropdownData: state.AttendanceExtraDutyReducer?.claimDropdownData ?? [],
      dropdownAutoExtraDutyList: state.EmployeeDetailsReducer?.dropdownAutoExtraDutyList ?? [],
      loading: state.EmployeeDetailsReducer?.loading || state.AttendanceExtraDutyReducer?.loading ,
      error: state.EmployeeDetailsReducer?.error || state.AttendanceExtraDutyReducer?.error ,
      success: state.EmployeeDetailsReducer?.success || state.AttendanceExtraDutyReducer?.success ,
    }));
  const dispatch = useDispatch()
  const shiftOptions =
    claimDropdownData?.shift_details?.map((item) => ({
      value: item.shift_id,
      label: item.shift_name,
    })) ?? [];

  const locationOptions =
    claimDropdownData?.location_details?.map((item) => ({
      value: item.pre_id,
      label: item.premises_name,
    })) ?? [];

  useEffect(() => {
    if (success) {
      formik.resetForm();
    }
  }, [authDetails, success, dispatch]);

  const formik = useFormik({
    initialValues: {
      employee: null,        
      workedAt: null,        
      workedAs: null,        
      fromDate: "",          
      fromTime: "",          
      toTime: "",            
      reason: "",            
      totalHours: "",        
    },
    validationSchema: Yup.object({
      employee: Yup.object().nullable().required("Employee is required"),
      workedAt: Yup.object().nullable().required("Worked At is required"),
      workedAs: Yup.object().nullable().required("Worked As is required"),
      // fromDate: Yup.date().nullable().required("Claim Date is required"),
      fromTime: Yup.date()
        .nullable()
        .required("From Time is required"),      
      toTime: Yup.date()
        .nullable()
        .required("To Time is required")
        .when("fromTime", (fromTime, schema) => {
          return fromTime
            ? schema.min(fromTime, "To Time must be after From Time")
            : schema;
        }),
      totalHours: Yup.number()
        .nullable()
        .typeError("Invalid hours")
        .positive("Total Hours must be greater than 0")
        .required("Total Hours is required"),
      reason: Yup.string().required("Reason is required"),
    }),
    onSubmit: (values) => {
      console.log("Form Values:", values);

      // Split date & time for fromTime
      // let fromDateOnly = "";
      // let fromTimeOnly = "";
      // if (values?.fromTime) {
      //   const [date, time, meridian] = values.fromTime.split(" ");
      //   fromDateOnly = date;
      //   fromTimeOnly = `${time} ${meridian}`;
      // }

      // // Split date & time for toTime
      // let toDateOnly = "";
      // let toTimeOnly = "";
      // if (values?.toTime) {
      //   const [date, time, meridian] = values.toTime.split(" ");
      //   toDateOnly = date;
      //   toTimeOnly = `${time} ${meridian}`;
      // }

      const fromDateOnly = values.fromTime ? dayjs(values.fromTime).format("YYYY-MM-DD") : "";
      const fromTimeOnly = values.fromTime ? dayjs(values.fromTime).format("hh:mm A") : "";

      const toDateOnly = values.toTime ? dayjs(values.toTime).format("YYYY-MM-DD") : "";
      const toTimeOnly = values.toTime ? dayjs(values.toTime).format("hh:mm A") : "";

      const formData = new FormData();
      formData.append("emp_id", values?.employee?.value || 0);
      formData.append("from_dt", fromDateOnly);
      formData.append("from_time", fromTimeOnly);
      formData.append("to_dt", toDateOnly);
      formData.append("to_time", toTimeOnly);
      formData.append("reason", values?.reason || "");
      formData.append("worked_as", values?.workedAs?.value || 0);
      formData.append("worked_at", values?.workedAt?.value || 0);
      formData.append("unit_id", authDetails?.unit_id || 0);
      formData.append("create_by", authDetails?.user_id || 0);

      dispatch(saveExtraDutyClaim(formData));
    },
  });

  useEffect(() => {
    const authUserDetails = useAuthUserDetails();
    setAuthDetails(authUserDetails[0])
    const unitId = authUserDetails[0].unit_id
    dispatch(fetchEmployeeDropdownAutoExtraDutyList(unitId));
//    dispatch(fetchEmployeeDropdownAutoList(unitId));
    dispatch(fetchClaimDropdown(unitId))
  }, [dispatch]);

  // select custome style
  const SelectcustomStyles = {
    control: (base) => ({
      ...base,
      maxheight: 33.1,
      minHeight: 33.1,
      // overflow: "scroll",
    }),
    indicatorsContainer: (base) => ({
      ...base,
      padding: "0", // Match the padding for both dropdown and clear indicator
    }),
    dropdownIndicator: (base) => ({
      ...base,
      padding: "2px 8px", // Ensure consistent padding for dropdown indicator
    }),
    clearIndicator: (base) => ({
      ...base,
      padding: "2px 8px", // Adjust padding for clear indicator to match dropdown
    }),
  };

  const updateTotalHours = (fromDateTime, toDateTime) => {
    if (!fromDateTime || !toDateTime) return;

    const start = new Date(fromDateTime);
    const end = new Date(toDateTime);

    let diffMs = end - start;

    // If To Time is earlier than From Time → assume overnight shift (next day)
    if (diffMs < 0) {
      diffMs += 24 * 60 * 60 * 1000;
    }

    // Convert milliseconds → total minutes
    const totalMinutes = Math.floor(diffMs / (1000 * 60));
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    // Format for display
    const formatted = `${hours}.${minutes.toString().padStart(2, "0")}`;

    formik.setFieldValue("totalHours", formatted);
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Loader loading={loading}/>
        <Container fluid>
          <Breadcrumbs title="Extra Duty" breadcrumbItem="Claim" />

          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <form onSubmit={formik.handleSubmit}>
                    <Row>
                      {/* Employee Selection */}
                      <Col md={4}>
                        <FormGroup>
                          <Label for="employee">Employee <span className="text-danger">*</span></Label>
                          <CustomSelect
                            id="employee"
                            name="employee"
                            options={(dropdownAutoExtraDutyList || []).map(emp => ({ value: emp.emp_id.toString(), label: emp.emp_no }))}
                            value={formik.values.employee || null}
                            onChange={(selectedOption) => formik.setFieldValue("employee", selectedOption)}
                            onBlur={formik.handleBlur}
                            className={formik.touched.employee && formik.errors.employee ? "is-invalid" : ""}
                          />
                          {formik.touched.employee && formik.errors.employee && (
                            <div className="text-danger">{formik.errors.employee}</div>
                          )}
                        </FormGroup>
                      </Col>

                      {/* Worked At Selection */}
                      <Col md={4}>
                        <FormGroup>
                          <Label for="workedAt">Worked At <span className="text-danger">*</span></Label>
                          <CustomSelect
                            id="workedAt"
                            name="workedAt"
                            options={locationOptions || []}
                            value={formik.values.workedAt || null}
                            onChange={(selectedOption) => formik.setFieldValue("workedAt", selectedOption)}
                            onBlur={formik.handleBlur}
                            className={formik.touched.workedAt && formik.errors.workedAt ? "is-invalid" : ""}
                          />
                          {formik.touched.workedAt && formik.errors.workedAt && (
                            <div className="text-danger">{formik.errors.workedAt}</div>
                          )}
                        </FormGroup>
                      </Col>

                      {/* Worked As Selection */}
                      <Col md={4}>
                        <FormGroup>
                          <Label for="workedAs">Worked As <span className="text-danger">*</span></Label>
                          <CustomSelect
                            id="workedAs"
                            name="workedAs"
                            options={shiftOptions || []}
                            value={formik.values.workedAs || null}
                            onChange={(selectedOption) => formik.setFieldValue("workedAs", selectedOption)}
                            onBlur={formik.handleBlur}
                            className={formik.touched.workedAs && formik.errors.workedAs ? "is-invalid" : ""}
                          />
                          {formik.touched.workedAs && formik.errors.workedAs && (
                            <div className="text-danger">{formik.errors.workedAs}</div>
                          )}
                        </FormGroup>
                      </Col>
                      {/* <Col md={3}>
                        <FormGroup>
                          <Label for="fromDate">Claim Date *</Label>
                          <CustomDatePicker
                            name="fromDate"
                            value={formik.values.fromDate}
                            onChange={(date) => formik.setFieldValue("fromDate", date)}
                            onBlur={formik.handleBlur}
                            disableFuture={true}
                            className={`form-control ${formik.touched.fromDate && formik.errors.fromDate ? "is-invalid" : ""}`}
                          />
                          {formik.touched.fromDate && formik.errors.fromDate && (
                            <div className="text-danger">{formik.errors.fromDate}</div>
                          )}
                        </FormGroup>
                      </Col> */}

                     {/* From Time */}
                      <Col md={4}>
                        <FormGroup>
                          <Label for="fromTime">From Time <span className="text-danger">*</span></Label>
                          <CustomDateTimePicker
                            name="fromTime"
                            value={formik.values.fromTime || null}
                            onChange={(val) => {
                              console.log('val > ',val)
                              formik.setFieldValue("fromTime", val);
                              updateTotalHours(val, formik.values.toTime);
                            }}
                            onBlur={() => formik.setFieldTouched("fromTime", true)}
                            placeholder="Select Time"
                            disableFuture={true}
                          />
                          {formik.touched.fromTime && formik.errors.fromTime && (
                            <div className="text-danger">{formik.errors.fromTime}</div>
                          )}
                        </FormGroup>
                      </Col>

                      {/* To Time */}
                      <Col md={4}>
                        <FormGroup>
                          <Label for="toTime">To Time <span className="text-danger">*</span></Label>
                          <CustomDateTimePicker
                            name="toTime"
                            value={formik.values.toTime || null}
                            onChange={(val) => {
                              formik.setFieldValue("toTime", val);
                              updateTotalHours(formik.values.fromTime, val);
                            }}
                            onBlur={() => formik.setFieldTouched("toTime", true)}
                            placeholder="Select Time"
                            disableFuture={true}
                          />
                          {formik.touched.toTime && formik.errors.toTime && (
                            <div className="text-danger">{formik.errors.toTime}</div>
                          )}
                        </FormGroup>
                      </Col>

                      {/* Total Hours */}
                      <Col md={4}>
                        <FormGroup>
                          <Label>Total Hours <span className="text-danger">*</span></Label>
                          <div className="form-control-plaintext">
                            {formik.values.totalHours ? `${formik.values.totalHours} hours` : "--"}
                          </div>
                        </FormGroup>
                      </Col>
                    </Row>

                    <Row>
                      {/* Reason */}
                      <Col md={8}>
                        <FormGroup>
                          <Label for="reason">Reason <span className="text-danger">*</span></Label>
                          <Input
                            type="textarea"
                            name="reason"
                            id="reason"
                            value={formik.values.reason}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            invalid={formik.touched.reason && formik.errors.reason ? true : false}
                          />
                          {formik.touched.reason && formik.errors.reason && (
                            <div className="text-danger">{formik.errors.reason}</div>
                          )}
                        </FormGroup>
                      </Col>
                    </Row>

                    <Row>
                      <Col md={12} className="text-end mob-center">
                        {canCreate && (
                           <Button type="submit" className="btn button-save me-2">
                            <i className="fas fa-save me-1" /> Claim
                          </Button>
                        )}
                       
                        <Button type="reset" onClick={formik.handleReset} className="btn button-cancel"> <i className="fas fa-sync me-1" /> Cancel
                        </Button>
                      </Col>
                    </Row>
                  </form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Claim;
